/**
 * Features that are built but not live.
 *
 * A flag here is the same switch as the server's: with it off the feature is
 * not merely hidden, it does not happen. The chests are built, reviewed on
 * dev, and waiting on a grade and Adam's word — so on prod the server awards
 * none and serves 404s, and the client draws nothing and asks for nothing.
 *
 * `VITE_CHESTS` mirrors the server's `CHESTS_ENABLED`; both default to off, so
 * a deploy that forgets one of them still ships a coherent game rather than a
 * client asking for routes that answer 404.
 */
const on = (value: unknown): boolean =>
  typeof value === 'string' && /^(1|true|on|yes)$/i.test(value);

export const CHESTS_ENABLED = on(import.meta.env?.VITE_CHESTS);

/**
 * The weekly X faucet ("Free tokens"). `VITE_FAUCET` mirrors the server's `FAUCET_ENABLED`; off by default on both.
 * Off means the entry is not drawn anywhere (home, your own profile, the screen itself) and nothing is asked of the
 * API, which answers 404 to the faucet's routes with the flag off.
 */
export const FAUCET_ENABLED = on(import.meta.env?.VITE_FAUCET);
